/**
 * Role enum — mirrors backend `eRole` enum.
 * Keep in sync with: public enum eRole { SuperAdmin=1, OrgAdmin=2, ... }
 */
export const eRole = {
  SuperAdmin:   1,
  OrgAdmin:     2,
  ZoneAdmin:    3,
  FleetAdmin:   4,
  DriverUser:   5,
  OperatorUser: 6,
  GlobalSystemAdmin: 7,
};

/**
 * Roles allowed to immobilize a vehicle (POST /api/Vehicle/EngineCut) and to
 * create, edit or delete a geofence.
 *
 * This is a MIRROR of the backend's admin check, kept here so the UI does not
 * offer a control that can only fail. It is not the security boundary — the
 * server answers 403 regardless of what this set says, and the callers still
 * handle that 403. Anything gated on this must also degrade gracefully when
 * the backend disagrees.
 *
 * Drivers and operators are excluded; every admin tier is allowed, because the
 * backend resolves fleet and zone scope itself and answers 403 for a vehicle
 * outside the caller's reach.
 */
export const ENGINE_CUT_ROLE_IDS = new Set([
  eRole.SuperAdmin,
  eRole.OrgAdmin,
  eRole.ZoneAdmin,
  eRole.FleetAdmin,
]);

/** Same admin set — both endpoints share one backend authorization rule. */
export const GEOFENCE_ADMIN_ROLE_IDS = ENGINE_CUT_ROLE_IDS;
